import request from './base'

export const deliveryList = (params) => {
    return request.post("/admin/v1/delivery/list",params)
}

export const deliChangeStatus = (params) => {
    return request.post("/admin/v1/delivery/changeStatus",params)
}

// 获取上传到阿里云的路径
export const uploadpicture = (params) => {
    return request.post("/admin/v1/delivery/uploadpicture",params)
}

//put文件上传
export const uploadPutPic = (url,params, callBack,content_type) => {
    return request.uploadPutFile(url, params, callBack,content_type)
}

//图片查看
export const viewpic = (params) => {
    return request.post("/admin/v1/delivery/viewpic",params)
}





// WEBPACK FOOTER //
// ./src/api/delivery.js